/**
 * Het adres waar een deelnemer terechtkan als er iets niet klopt.
 *
 * ┌─ Waarom dit hier hardgecodeerd staat en niet uit een instelling komt ────────────┐
 * │ Er is geen publieke bron voor dit adres. `support_email` bestaat wél als          │
 * │ beheerinstelling, maar dat eindpunt (`/api/admin/instellingen`) vraagt om een     │
 * │ inlog, en de instelling wordt in géén enkele migratie gevuld — hij is dus in de   │
 * │ praktijk leeg. De mailer leest hem ook niet: `backend/app/services/email_sender.py`│
 * │ zet er zijn eigen waarde neer. Zou de gegevenspagina die instelling gebruiken,    │
 * │ dan stond er nu een blanco adres onder "neem contact op" — een doodlopende weg    │
 * │ voor precies de deelnemer die hulp nodig heeft.                                   │
 * └──────────────────────────────────────────────────────────────────────────────────┘
 *
 * Deze waarde is daarom bewust gelijkgehouden aan de waarde in `email_sender.py`
 * (`_values_voor_werknemer_email`, de placeholder `support_email`). Wijzigt er één, dan
 * moet de ander mee — de verwijzing staat in beide bestanden.
 *
 * Wanneer dit weg mag: zodra de multi-tenant-bron er is (de `applicatie_settings`-tabel
 * uit de aantekening in `email_sender.py`, V1.5-werk). Dan lezen de mailer én dit scherm
 * dezelfde waarde en verdwijnt deze constante. Een publiek instellingen-eindpunt erbij
 * bouwen is bewust NIET gedaan: dat vergroot wat er met een persoonlijke sleutel op te
 * halen valt, terwijl de gegevenspagina juist zo min mogelijk hoort terug te geven.
 */
export const SUPPORT_EMAIL = "info@fulkraworks.nl";
